// CommonAutocomplete.jsx
import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

const CommonAutocomplete = ({
  label,
  value,
  onChange,
  options,
  getOptionLabel,
  error,
  helperText,
}) => {
  return (
    // <Autocomplete
    //   fullWidth
    //   size="small"   
    //   value={value}
    //   onChange={onChange}
    //   options={options}
    //   getOptionLabel={getOptionLabel}
    //   renderInput={(params) => (
    //     <TextField
    //     {...params}
    //      // variant="outlined"       
    //       variant="outlined"   
    //       error={error && error.length > 0}
    //       helperText={helperText}

    //       label={label}

    //     />
    //   )}
    // />
    <Autocomplete
      fullWidth
      size="small"
      value={value}
      onChange={(event, newValue) => {
        if (typeof onChange === 'function') {
          onChange(event, newValue);
        } else {
          console.warn('onChange is not a function');
        }
      }}
      options={options}
      getOptionLabel={(option) =>
        typeof option === 'string' ? option : option?.description || ''
      }
      isOptionEqualToValue={(option, value) => option?.id === value?.id}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label={label}
          error={Boolean(error)}
          helperText={helperText}
        />
      )}
    />
  );
};

export default CommonAutocomplete;
